// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__hTt-Y","containerDescription":"footer_containerDescription__35cFW","containerPopular":"footer_containerPopular__3QlXm","containerForm":"footer_containerForm__1zWPC","content":"footer_content__bTruR"};
    if(module.hot) {
      // 1746390043946
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  